import { Box, Card, CardContent, IconButton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, Tooltip } from "@mui/material"
import { formatBytes } from "../utils/ByteConverter"
import { StoragePackDistribution } from "./StoragePackDistribution"
import { useState } from "react";

export const StoragePack = ({id, type, size, distributions, owner, renewalDate}) => {

  const [tab, setTab] = useState(0);

  const handleChange = (event, newTab) => {
    setTab(newTab);
  }

  const renderStoragePack = () => (
    <Card sx={{ color: "black" }}>
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>{id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>{type}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Owner</TableCell>
              <TableCell>{owner ? owner: "NONE"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Size</TableCell>
              <TableCell>{formatBytes(size)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Renewal Date</TableCell>
              <TableCell>{renewalDate ? renewalDate : "NEVER"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );

  const renderDistributions = () => (
    <Card sx={{ color: "black" }}>
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Area ID</TableCell>
              <TableCell>Size</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {distributions?.map(dist => (
              <StoragePackDistribution key={dist.id} areaId={dist.areaId} size={dist.size} />
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );

  return (
    <Box
      sx={{
        width: "30%",
        border: "2px solid black",      // border around the whole structure
        borderRadius: 1,
        overflow: "hidden",
        margin: "10px"
      }}
    >
      <Tabs
        value={tab}
        onChange={handleChange}
        variant="fullWidth"
  sx={{
    "& .MuiTab-root": {
      backgroundColor: "white",
      color: "black",
    },
    "& .MuiTab-root.Mui-selected": {
      backgroundColor: "#A60F2D",
      color: "white",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  }}
      >
        <Tab label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  Storage Pack Information
                </Box>  
        }     
        />
        <Tab label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  Distribution Information
                </Box>  
        } />
      </Tabs>

      {tab === 0 && renderStoragePack()}
      {tab === 1 && renderDistributions()}
    </Box>
  );
};